export type TaskSearchFields = {
  task_name?: string | null;
  description?: string | null;
  object_name?: string | null;
};

export const matchesTaskSearch = (
  task: TaskSearchFields,
  search: string | null | undefined
): boolean => {
  const term = (search ?? "").trim().toLowerCase();
  if (!term) return true;

  return [task.task_name, task.description, task.object_name].some((field) =>
    (field ?? "").toLowerCase().includes(term)
  );
};
